import { Flex } from "@common/components/Flex";
import { I18n } from "react-redux-i18n";
import { getTestAttributes } from "@common/utils/tests";
import { MODULE_NAME } from '@modules/individuals';
import { FormControl } from '@common/components/form-control';
import { isEmail } from '@common/utils/email';

import "./email-address.styles.scss";

export const EmailAddress = (props) => {
  const { defaultValue, onChange } = props;
  const localModuleName = `${MODULE_NAME}-new-invite-email-address`;
  const [currentValue, setCurrentValue] = React.useState(defaultValue || '');
  const [showValidation, setShowValidation] = React.useState(false);

  const handleChange = React.useCallback((e) => {
    const value = e.target.value.trim();
    setCurrentValue(value);
    setShowValidation(true); // Show validation while typing
    onChange(value);
  }, [onChange]);

  const handleBlur = React.useCallback((e) => {
    const value = e.target.value.trim();
    setCurrentValue(value);
    setShowValidation(true);
    onChange(value);
  }, [onChange]);

  const isValid = isEmail(currentValue);
  const showError = showValidation && currentValue && !isValid;

  return (
    <div className="IndividualsEmailAddress">
      <h6 className="IndividualsEmailAddress__title">{I18n.t("There is a problem with the email address for this individual, please enter a valid email address")}</h6>

      <Flex justify="center" width="100%">
        <div className="IndividualsEmailAddress__input-container">
          <FormControl
            value={currentValue}
            type="text"
            onChange={handleChange}
            onBlur={handleBlur}
            className={showError ? 'error' : ''}
            {...getTestAttributes({ id: 'tx-bwstep-quest-email' })}
          />
          {showError && (
            <div className="IndividualsEmailAddress__error">
              {I18n.t("Please enter a valid email address")}
            </div>
          )}
        </div>
      </Flex>
    </div>
  );
};
